module.exports = __webpack_public_path__ + "media/49D888piCn5m.1333bc30.mp3";